import { createSelector } from 'reselect'
import { IStore } from '../../reducers/index'

const charactersSelector = (state: IStore) => state.app.skin.characters

export default createSelector(charactersSelector, (characters) => {
	return characters
})
